export const fevicolInhomzRootRoute = ''